import PropTypes from "prop-types";
import { getCollections } from "lib/api";
import Meta from "solar/components/Meta";
import LayoutCollections from "components/layouts/LayoutCollections";
import List from "components/collections/List";

export default function Collections({ collections }) {
  return (
    <>
      <Meta
        title="Curated collections of surf trips"
        description="Surf trips for surfers of all levels. The world is bigger and more interesting on a surfboard. We're here to prove it."
        path="/collections"
        imageOgUrl="https://www.thermal.travel/meta/collections-og.jpg"
        imageTwitterUrl="https://www.thermal.travel/meta/collections-twitter.jpg"
        imageType="image/jpeg"
      />
      <List collections={collections} />
    </>
  );
}

export async function getStaticProps() {
  const response = await getCollections();
  if (response.errorMsg) {
    return { props: {} };
  }
  return {
    props: {
      collections: response.filter(
        (collection) => collection.is_visible === true
      ),
    },
    revalidate: 1800,
  };
}

Collections.Layout = LayoutCollections;

Collections.propTypes = {
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      is_visible: PropTypes.bool,
      name: PropTypes.string,
      num_trips: PropTypes.number,
      slug: PropTypes.string,
    })
  ).isRequired,
};
